import PropTypes from 'prop-types';
var headerProps = {
  'aria-label': PropTypes.string,
  centralArea: PropTypes.node,
  endArea: PropTypes.node,
  id: PropTypes.string,
  startArea: PropTypes.node,
  previewArea: PropTypes.node
};
var itemsProps = {
  content: PropTypes.node,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  header: PropTypes.shape(headerProps),
  id: PropTypes.string
};
var propTypes = {
  appearance: PropTypes.oneOf(['dropShadow', 'outlined']),
  behavior: PropTypes.oneOf(['multiExpand', 'singleExpand']),
  gutter: PropTypes.number,
  hoverable: PropTypes.bool,
  id: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(itemsProps).isRequired),
  onCollapse: PropTypes.func,
  onExpand: PropTypes.func,
  onScrollEnd: PropTypes.func,
  scrollEndOffset: PropTypes.number
};
export default propTypes;